import * as React from "react"
import styled from "styled-components";
import { rhythm, scale } from "../utils/typography";
import ReactHtmlParser from "react-html-parser";
import Block from "./blocksDescriptionComponents";
import Img from "gatsby-image";


const WhiteBlocksDescription = (props) => {

    const blocksDescription = props;

    return (
        <>
            <Block>
                <div className="white-paragraph">

                    <div className="col">
                      <div className="paragraph" style={{padding: "1.6rem 5vw 4.8rem !important"}}>
                        {ReactHtmlParser(blocksDescription.sections.left.content)}
                      </div>
                    </div>

                    <div className="col picture">
                        <div className="list-white">
                          <Img fluid={blocksDescription.sections.left.image.childImageSharp.fluid}
                               style={{marginTop: "-70px"}}></Img>  
                        </div>
                    </div>

                </div>
            </Block>
        </>
    );
};

export default WhiteBlocksDescription;